// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"638":"31d6cfe0","843":"f8057f8f"}[chunkId] + ".chunk.css";
};